module.exports = __webpack_public_path__ + "static/img/yi.10c54ca6.png";